import React from 'react';
import {
  AnswerApplicationQuestionRequest,
  FieldObject,
  FieldObjectTypeEnum,
} from '../../../../openapi/atlantis';
import ConfigDrivenConditionalFormFieldArrayInputV2 from './ConfigDrivenConditionalFormFieldArrayInputV2';
import ConfigDrivenConditionalFormInputV2 from './ConfigDrivenConditionalFormInputV2';

interface ConfigDrivenFormInputsV2Props {
  field: FieldObject;
  questionAlias?: string;
  onSubmit: (e: AnswerApplicationQuestionRequest) => void;
  isSubmitting: boolean;
  checklistItemId: string;
  onNavigateToQuestion?: (questionId: string) => Promise<void>;
}

const ConfigDrivenFormInputsV2: React.FC<ConfigDrivenFormInputsV2Props> = ({
  field,
  questionAlias,
  onSubmit,
  isSubmitting,
  checklistItemId,
  onNavigateToQuestion,
}) => {
  const isFieldArray = field.type === FieldObjectTypeEnum.FieldArray;

  if (isFieldArray) {
    return (
      <ConfigDrivenConditionalFormFieldArrayInputV2
        field={field}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        checklistItemId={checklistItemId}
        onNavigateToQuestion={onNavigateToQuestion}
      />
    );
  }

  return (
    <ConfigDrivenConditionalFormInputV2
      name={field.id}
      field={field}
      questionAlias={questionAlias}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      checklistItemId={checklistItemId}
      onNavigateToQuestion={onNavigateToQuestion}
    />
  );
};

export default ConfigDrivenFormInputsV2;
